import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { computed, ref } from "vue";
export default {
  props: ["paperInfo", "itemNo", "answers", "paperNo"],
  setup(props, content) {
    let numChat = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
    let menuTaskNo = ref(-1);
    let menuList = computed(() => {
      let paperList = [];
      let totalTask = 0;
      if (props.paperInfo[0]) {
        props.paperInfo.forEach((paperItem, paperIndex) => {
          let list = [];
          let task = 0;
          paperItem.items.forEach((item, index) => {
            if (index == props.itemNo && menuTaskNo.value == -1) {
              menuTaskNo.value = task;
            }
            if (item.questionGroupList) {
              item.questionGroupList.forEach(taskItem => {
                taskItem.questionList.forEach(questionItem => {
                  if (questionItem.questionScore) {
                    if (props.answers && (props.answers[questionItem.questionId] || props.answers[questionItem.questionId] === 0)) {
                      list.push({
                        menuTaskNo: task,
                        totalTask: totalTask,
                        itemNo: index,
                        isfinish: true,
                        paperIndex
                      });
                    } else {
                      list.push({
                        totalTask: totalTask,
                        menuTaskNo: task,
                        itemNo: index,
                        isfinish: false,
                        paperIndex
                      });
                    }
                    task++;
                    totalTask++;
                  }
                });
              });
            }
          });
          paperList.push(list);
        });
      }
      content.emit("setTotalNo", totalTask);
      return paperList;
    });
    // 设置前卷题数
    function change(msg) {
      if (msg.menuTaskNo != menuTaskNo.value) {
        menuTaskNo.value = msg.menuTaskNo;
        if (msg.itemNo != props.itemNo) {
          content.emit("changeItem", msg.itemNo);
        }
      }
    }
    function changePaper(msg, itemNo = 0, menuTask = 0) {
      if (msg != props.paperNo) {
        menuTaskNo.value = menuTask;
        content.emit("changeItem", 0);
        content.emit("changePaper", msg);
        content.emit("changeItem", itemNo);
      }
    }
    //下一题
    function next() {
      //最后一题
      if (menuList.value[props.paperNo][menuList.value[props.paperNo].length - 1].itemNo == props.itemNo) {
        //在最后一卷
        if (props.paperNo - 1 == props.paperInfo.length) {
          return 0;
        }
        //换卷
        else {
          menuTaskNo.value = 0;
          content.emit("changeItem", 0);
          changePaper(props.paperNo + 1);
          return 0;
        }
      }
      for (let i = menuTaskNo.value + 1; i < menuList.value[props.paperNo].length; i++) {
        if (menuList.value[props.paperNo][i].itemNo != props.itemNo) {
          menuTaskNo.value = menuList.value[props.paperNo][i].menuTaskNo;
          content.emit("changeItem", menuList.value[props.paperNo][i].itemNo);
          break;
        }
      }
    }
    //上一题
    function back() {
      //已经第一题
      if (menuList.value[props.paperNo][0].itemNo == props.itemNo) {
        if (props.paperNo == 0) {
          return 0;
        } else {
          changePaper(props.paperNo - 1, menuList.value[props.paperNo - 1][menuList.value[props.paperNo - 1].length - 1].itemNo, menuList.value[props.paperNo - 1][menuList.value[props.paperNo - 1].length - 1].menuTaskNo);
          return 0;
        }
      }
      for (let i = menuTaskNo.value - 1; i >= 0; i--) {
        if (menuList.value[props.paperNo][i].itemNo != props.itemNo) {
          menuTaskNo.value = menuList.value[props.paperNo][i].menuTaskNo;
          content.emit("changeItem", menuList.value[props.paperNo][i].itemNo);
          break;
        }
      }
    }
    return {
      numChat,
      menuList,
      menuTaskNo,
      change,
      next,
      back,
      changePaper
    };
  }
};